import { render, staticRenderFns } from "./AlertaCriticaCard.vue?vue&type=template&id=2b3cd7cc&scoped=true&lang=pug"
import script from "./AlertaCriticaCard.vue?vue&type=script&lang=js"
export * from "./AlertaCriticaCard.vue?vue&type=script&lang=js"
import style0 from "./AlertaCriticaCard.vue?vue&type=style&index=0&id=2b3cd7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3cd7cc",
  null
  
)

export default component.exports